var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1001 12.936C8.1001 10.579 8.1001 9.4005 8.83233 8.66827C9.56456 7.93603 10.7431 7.93603 13.1001 7.93604L13.9334 7.93604C16.2905 7.93604 17.469 7.93604 18.2012 8.66827C18.9334 9.4005 18.9334 10.579 18.9334 12.936V13.7694C18.9334 16.1264 18.9334 17.3049 18.2012 18.0371C17.469 18.7694 16.2905 18.7694 13.9334 18.7694H13.1001C10.7431 18.7694 9.56456 18.7694 8.83233 18.0371C8.1001 17.3049 8.1001 16.1264 8.1001 13.7694L8.1001 12.936Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7665 7.93587C14.7646 5.47163 14.7272 4.19521 14.01 3.32123C13.8715 3.15245 13.7167 2.99769 13.5479 2.85917C12.626 2.10254 11.2562 2.10254 8.5166 2.10254C5.77703 2.10254 4.40725 2.10254 3.48529 2.85917C3.31651 2.99768 3.16175 3.15245 3.02323 3.32123C2.2666 4.24319 2.2666 5.61297 2.2666 8.35254C2.2666 11.0921 2.2666 12.4619 3.02323 13.3838C3.16175 13.5526 3.31651 13.7074 3.48529 13.8459C4.35927 14.5632 5.63569 14.6005 8.09994 14.6024",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.8b9a21601883cc1e52c2e869a2794c09.svg";
export { ForwardRef as ReactComponent };